import React, {Fragment,useRef,useState,forwardRef,useImperativeHandle} from "react";
import { useHistory } from 'react-router-dom';
import {Button} from 'devextreme-react/button';
import { LoadPanel } from 'devextreme-react/load-panel';
import Form, {Label, SimpleItem, RequiredRule, GroupItem, ButtonItem} from 'devextreme-react/form';
import paymentApi from '../../../../../api/payment';
import visa from '../../../../../assets/visa.png';
import DinerClub from '../../../../../assets/diner-club.png';
import AmericanExpress from '../../../../../assets/american-express.png';
import carteBancaire from '../../../../../assets/carte-bancaire.png';
import discover from '../../../../../assets/discover.png';
import MasterCard from '../../../../../assets/masterCard.png';
import unionPay from '../../../../../assets/union_pay.png';
import jcb from '../../../../../assets/jcb.png';
import addCard from '../../../../../assets/add-card.png';
import sessions from '../../../../../sessions';
import notify from 'devextreme/ui/notify';
import './index.scss';

const UserCardList = forwardRef(({data},ref) =>{
    const cardListData = data;
    const [isCCPopUpVisible,setIsCCPopUpVisible] = useState(false);
    const [isCardSelected, setIsCardSelected] = useState(false);
    const [selectedCardID, setSelectedCardID] = useState();
    const [isloadPanelVisible, setIsloadPanelVisible] = useState(false);
    const userId = sessions.getSession("user")?.id;
    const auth = sessions.getSession("user")?.accessToken;
    const history = useHistory();

    const checkoutForm = useRef({});
    const childRef = useRef();
    const CCButton = {
        text: 'pay',
        useSubmitBehavior: true,
        validationGroup: 'group',
        onClick: () => childRef
            .current
            .onSubmit()
    };

    const CCCancelButton = {
        text: 'cancel',
        onClick: () => {
            setIsCCPopUpVisible(false);
        }
    };

    const bankCard = (type) =>{
        switch(type){
            case 'amex':
                return(<img alt={"amex"} src={AmericanExpress} className={'bank-card'}/>);
            case 'cartes_bancaires':
                return(<img alt={"cartes_bancaires"} src={carteBancaire} className={'bank-card'}/>);
            case 'diners':
                return(<img alt={"diners"} src={DinerClub} className={'bank-card'}/>);
            case 'diners_club':
                return(<img alt={"diners_club"} src={DinerClub} className={'bank-card'}/>);
            case 'discover':
                return(<img alt={"discover"} src={discover} className={'bank-card'}/>);
            case 'visa':
                return(<img alt={"visa"} src={visa} className={'bank-card'}/>);
            case 'mastercard':
                return(<img alt={"MasterCard"} src={MasterCard} className={'bank-card'}/>);
            case 'unionpay':
                return(<img alt={"UnionPay"} src={unionPay} className={'bank-card'}/>);
            case 'jcb':
                return(<img alt={"JCB"} src={jcb} className={'bank-card'}/>);
            default:
                return '';
        };
    };

    const AddButton = () =>{
        return(
            <Button width={'15vw'} height={'20vh'} onClick={()=>setIsCCPopUpVisible(true)}>
            <div className={'stripe-card-box'}>
                <img alt={'add-card'} src={addCard} className={'add-card'}/>
            </div>
            </Button>
        )
    };

    const cardButtonOnClick = (id) =>{
        setSelectedCardID(id);
        if(id){
            setIsCardSelected(true);
        }
    }

    const List = cardListData?.map((item,index)=>{
        console.log(item);
        var type = item.card.brand;
        
        return(
            <Button key={index} id={item.id} className={'mr-2'} width={'15vw'} height={'20vh'} onClick={()=>{cardButtonOnClick(item.id)}}>
                <div className={'stripe-card-box'}>
                    <div className={'bank-title'}>
                        {bankCard(type)}
                    </div>
                    <div>
                        <div className={'bank-no'}><b>*** *** ****{item.card.last4}</b></div>
                        <div>
                            <span><b>{item.card.exp_month}/</b></span>
                            <span><b>{item.card.exp_year}</b></span>
                        </div>
                    </div>
                </div>
            </Button>
        )
    }); 

    const onSubmit = (async(e) => {
        const {amount} = checkoutForm.current;
        const payload = {
            paymentMethodId:selectedCardID,
            amount:amount
        };
        await paymentApi.createPaymentFromExistingAccount(userId,payload,auth).then(async(result)=>{
            setIsloadPanelVisible(false);
            notify(`✔️ succesfully add ${amount} USD to your account`,"success",500);
            history.replace(`/settings/subscription-plans`);
        }).catch(err=>{
            console.log(err);
            setIsloadPanelVisible(false);
            notify(`❌ Please try again later`,"error",500);
        });
    });

    useImperativeHandle(ref, (e) => ({onSubmit}));

    return(
        <Fragment>
            <div id={'card-list'}>
            {/*
            <Popup
                title={`Pay with Card`}
                visible={isCCPopUpVisible}
                width={'55vw'}
                height={'80vh'}
                onHiding={e => {setIsCCPopUpVisible(false)}}>
                <Elements stripe={stripePromise}>
                    <ScrollView><CardForm ref={childRef}/></ScrollView>
                </Elements>
                <ToolbarItem
                    widget="dxButton"
                    location="after"
                    toolbar='bottom'
                    options={CCButton}></ToolbarItem>
                <ToolbarItem
                    widget="dxButton"
                    location="after"
                    toolbar='bottom'
                    options={CCCancelButton}></ToolbarItem>
            </Popup>
            */}
            <div>
                <span>{List}</span>
            </div>
            <div>
                <Form formData={checkoutForm.current}>
                <SimpleItem 
                editorType="dxNumberBox" 
                dataField={'amount'}
                visible={isCardSelected}
                editorOptions={{
                    stylingMode:'outlined',
                    height:'35px',
                    width:'13vw',
                    format:'$ #.##',
                    }}>
                    <Label text={'Amount'}/>
                    <RequiredRule message={"amount is required"}/>
                </SimpleItem>
                </Form>
            </div>
            <LoadPanel
                position={'#card-list'}
                shadingColor="rgba(0, 0, 0, 0.2)"
                onHiding={!isloadPanelVisible}
                visible={isloadPanelVisible}
                showIndicator={true}
                shading={true}
                showPane={true}
                message={'loading..'}
                closeOnOutsideClick={false}/>
            </div>
        </Fragment>
    );
})
export default UserCardList;
